import { render, staticRenderFns } from "./DefaultContentLoader.vue?vue&type=template&id=2fdb5676&"
import script from "./DefaultContentLoader.vue?vue&type=script&lang=js&"
export * from "./DefaultContentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports